// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorCarts = (client) => ({
    /**
     * `POST /vendor/carts/:id/complete`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCartsIdCompleteCreate
     * @source packages/modules/b2c-core/src/api/vendor/carts/[id]/complete/route.ts
     */
    complete: (id, body, query, headers) => client.fetch(buildPath("/vendor/carts/:id/complete", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/carts`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCartsCreate
     * @source packages/modules/b2c-core/src/api/vendor/carts/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/carts", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/carts/:id/line-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCartsIdLineItemsCreate
     * @source packages/modules/b2c-core/src/api/vendor/carts/[id]/line-items/route.ts
     */
    createLineItem: (id, body, query, headers) => client.fetch(buildPath("/vendor/carts/:id/line-items", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/carts/:id/line-items/:line_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCartsIdLineItemsLineIdDelete
     * @source packages/modules/b2c-core/src/api/vendor/carts/[id]/line-items/[line_id]/route.ts
     */
    deleteLineItem: (id, lineId, body, query, headers) => client.fetch(buildPath("/vendor/carts/:id/line-items/:line_id", [id, lineId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/carts/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCartsIdRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/carts/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/carts/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=carts.js.map